import { leasingExpensesSchema } from "features/common/schemas";
import { denormalize } from "normalizr";
import createCachedSelector from "re-reselect";

const DEFAULT_EXPENSES_FLAGS = { loading: true, loaded: false };

const getFlags = (currentOfferExpensesState, _, _key) => {
  return currentOfferExpensesState || DEFAULT_EXPENSES_FLAGS;
};
const getLeasingExpensesState = (flags, entitiesExpensesState, key) => {
  return denormalize(key, leasingExpensesSchema, entitiesExpensesState);
};

export const getLeasingExpensesFlags = createCachedSelector(
  getFlags,
  flags => flags.loaded
)((_currentOfferExpensesState, _entitiesExpensesState, key) => key);

export const getLeasingExpenses = createCachedSelector(
  getLeasingExpensesFlags,
  getLeasingExpensesState,
  (loaded, leasingExpenses) => {
    if (!loaded) {
      return [];
    }
    return leasingExpenses;
  }
)((_currentOfferExpensesState, _entitiesExpensesState, key) => key);

export const getLeasingExpenseTypes = (key, state) => {
  if (!key) return { loading: false, loaded: false, result: [] };

  const leasingExpenseTypes = state.dictionaries.leasingExpenseTypes
    ? state.dictionaries.leasingExpenseTypes[key]
    : null;

  const loading = leasingExpenseTypes?.loading ? leasingExpenseTypes.loading : false;
  const loaded = leasingExpenseTypes?.loaded ? leasingExpenseTypes.loaded : false;
  const result = leasingExpenseTypes?.result ? leasingExpenseTypes.result : [];

  return { loading, loaded, result };
};
